import React, { Fragment } from 'react'
import { compose, branch } from 'recompose'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { Checkbox } from 'informed'
import styles from './Checkbox.module.scss'
import { withFieldSubmit } from '../Form'

const StyledCheckbox = ({ boxStyles, compareTodayStyled, compareWithStyled, smartSubmit, inline, styleInverted, noForm, label, stopPropagation, indeterminate, checkOnLabelClick, hidden, readOnly, ...rest }) => {
	const stopClickPropagation = e => {
		if (stopPropagation) {
			e.stopPropagation()
		}
	}

	let checkbox = (
		<Fragment>
			{(noForm || !rest.field) ?
				<input type='checkbox' {...rest} /> :
				<Checkbox
					{...rest}
					onChange={e => {
						if (rest.onChange) {
							rest.onChange(e)
						}
						if (smartSubmit) {
							smartSubmit.submit(e)
						}
					}} />
			}
			<span
				className={classNames('box', styles.box)}
				style={boxStyles}
			/>
		</Fragment>
	)
	checkbox = checkOnLabelClick ?
		(<label className={styles.label} onClick={stopClickPropagation}>
			{checkbox}
			<span className={styles.labelText}>{label}</span>
		</label>) :
		(<div className={styles.label}>
			<label onClick={stopClickPropagation}>{checkbox}</label>
			{label}
		</div>)


	return (
		<div
			onClick={e => {
				if(readOnly) {
					e.preventDefault()
				}
			}}
			className={
				classNames(
					styles.root,
					rest.className,
					{
						compare_today__active: compareTodayStyled,
						compare_with__active: compareWithStyled,
						inline: inline,
						[styles.inverted]: styleInverted,
						[`${'field-disabled'}`]: rest.disabled,
						[styles.indeterminate]: indeterminate && !rest.checked,
						[styles.hidden]: hidden,
						[styles.readOnly]: readOnly
					})
			}
		>
			{checkbox}
		</div>
	)
}

StyledCheckbox.propTypes = {
	field: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	inline: PropTypes.bool,
	styleInverted: PropTypes.bool,
	indeterminate: PropTypes.bool,
	noForm: PropTypes.bool,
	stopPropagation: PropTypes.bool,
	checkOnLabelClick: PropTypes.bool
}

StyledCheckbox.defaultProps = {
	checkOnLabelClick: true
}

export default compose(
	branch(
		({ noForm, field }) => (!noForm && field),
		withFieldSubmit
	)
)(StyledCheckbox)

